<template>
<span>
  <slot v-on:click="run">
    <b-tooltip label="Download as Excel" v-show="!running">
      <a href="#_" v-on:click="run">
        <b-icon
          pack="fas"
          icon="file-excel"
        />
      </a>
    </b-tooltip>
  </slot>
  <b-icon
    pack="fas"
    icon="circle-notch"
    class="fa-spin is-primary"
    v-show="running"
  />
</span>
</template>

<script>
import ReportActionMixin from '@frontend/dash3/js/components/reportbuilder/ReportActionMixin.js';
export default {
  data() {
    return {
      action: 'download_csv',
      shouldDownload: true,
    };
  },
  mixins: [ReportActionMixin],
  methods: {
    run: function() {
      // For Excel, we can directly navigate to the export URL instead of using the API
      const url = new URL(this.reportUrl, window.location.origin);
      const reportPath = url.pathname;
      const slug = reportPath.split('/').filter(s => s).pop(); // Get the last non-empty segment (slug)

      // Preserve all query parameters from the original report URL
      const queryString = url.search;
      const exportUrl = `/export-report-csv/${slug}/${queryString}`;

      window.location.href = exportUrl;
    },
  },
};
</script>

<style scoped>
</style>
